const Facebook = () => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="6.5 2 11 20"><path d="m16.883 12.877.486-3.555H13.64v-2.27c0-1.03.303-1.731 1.866-1.731H17.5V2.14A28.266 28.266 0 0 0 14.595 2C11.72 2 9.75 3.657 9.75 6.7v2.622H6.5v3.555h3.251V22h3.889v-9.123h3.243z" fill="#000"></path></svg>
)
export default Facebook;